<template>
  <div class="content">
    <h1 class="title">{{ $t("systemSettings.title") }}</h1>
    <v-card v-if="!isLoading" class="mt-10">
      <v-tabs
        v-model="activeTab"
        bg-color="white"
        show-arrows
        slider-color="teal-lighten-3"
      >
        <v-tab
          v-for="(tab, index) in tabs"
          :key="index"
          :value="tab.setting_type"
        >
          {{ $t(`systemSettings.tabs.${tab.setting_type}`) }}
        </v-tab>
      </v-tabs>
      <v-window v-model="activeTab">
        <v-window-item
          v-for="(tab, index) in forms"
          :key="index"
          :value="tab.setting_type"
        >
          <v-card>
            <h2 class="mt-4 mb-3 mx-4">
              {{ $t(`systemSettings.tabs.${tab.setting_type}`) }}
            </h2>
            <v-card
              v-for="(item, index) in tab.languages"
              :key="index"
              :value="item.language"
              class="mx-4 mb-4"
            >
              <v-card-title class="d-flex justify-space-between align-center">
                <h3 class="text-center">
                  {{ $t(`languages.${item.language.toUpperCase()}`) }}
                </h3>
                <v-btn
                  :icon="
                    item.isFormOpened ? 'mdi-chevron-up' : 'mdi-chevron-down'
                  "
                  @click="item.isFormOpened = !item.isFormOpened"
                ></v-btn>
              </v-card-title>
              <v-expand-transition>
                <div v-show="item.isFormOpened">
                  <v-card-text class="py-0">
                    <quill-editor
                      theme="snow"
                      contentType="html"
                      v-model:content="item.content"
                      @blur="onEditorBlur($event)"
                      @focus="onEditorFocus($event)"
                      @change="onEditorChange($event)"
                      @ready="onEditorReady($event)"
                    ></quill-editor>
                  </v-card-text>
                  <div class="d-flex justify-end mx-4 my-4">
                    <v-btn @click="handleSave(tab, item)" color="primary">{{
                      $t("systemSettings.button.save")
                    }}</v-btn>
                  </div>
                </div>
              </v-expand-transition>
            </v-card>
          </v-card>
        </v-window-item>
      </v-window>
    </v-card>
    <v-card v-else class="loading mt-10">
      <v-progress-circular
        v-if="isLoading"
        size="73.5"
        indeterminate
        class="loading-circle"
      ></v-progress-circular>
    </v-card>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "SystemSettings",
  props: {},
  components: {},
  data() {
    return {
      activeTab: "terms_and_conditions",
      tabs: [
        {
          setting_type: "terms_and_conditions",
        },
        {
          setting_type: "privacy_policy",
        },
        {
          setting_type: "faq",
        },
        {
          setting_type: "ticket_header",
        },
        {
          setting_type: "ticket_footer",
        },
        {
          setting_type: "voucher_header",
        },
        {
          setting_type: "voucher_footer",
        },
      ],
      show: false,
      isLoading: false,
      forms: [],
    };
  },
  created() {
    this.handleGetAdminSettings();
  },
  methods: {
    ...mapActions({
      getAdminSettings: "settings/getAdminSettings",
      updateAdminSettings: "settings/updateAdminSettings",
    }),

    addIsFormOpenedProperty() {
      for (const form of this.forms) {
        for (const language of form.languages) {
          language.isFormOpened = false;
        }
      }
    },

    handleGetAdminSettings() {
      this.isLoading = true;
      this.getAdminSettings()
        .then((res) => {
          this.isLoading = false;
          this.forms = res.list;
          this.addIsFormOpenedProperty();
        })
        .catch((error) => {
          this.isLoading = false;
          this.response = error.getMessage;
          console.log(error);
        });
    },

    handleSave(type, lang) {
      this.isLoading = true;
      const payload = {
        settingType: type.setting_type,
        content: lang.content,
        languageId: lang.id,
      };
      this.updateAdminSettings(payload)
        .then((res) => {
          this.isLoading = false;
          this.items = res.list;
        })
        .catch((error) => {
          this.isLoading = false;
          this.response = error.getMessage;
          console.log(error);
        });
    },

    onEditorBlur() {},
    onEditorFocus() {},
    onEditorChange() {},
    onEditorReady() {},
  },
};
</script>

<style lang="scss" scoped>
h2 {
  font-size: 25px;
}

.ql-container .ql-editor {
  height: 375px;
}

.v-window {
  .v-window__container {
    .v-window-item {
      transition: none;
    }
  }
}
</style>
